import IOApi from '@/api/IOApi'
import { IntervalReportNotification } from './IntervalReportNotification'
import { IntervalReportQuery } from './IntervalReportQuery'
import { IntervalMailSendingStatus } from './Constants'

export const IntervalReportFormFactory = async (
  advertiserId,
  isAdminUser,
  intervalReport = {},
) => {
  const form = new IntervalReportForm(advertiserId, isAdminUser, intervalReport)
  await form.fetchInsertionOrderList()
  await form.notification.setEmails()
  return form
}

class IntervalReportForm {
  constructor(loginAdvertiserId = null, isAdminUser, intervalReport = {}) {
    const {
      id = 0,
      name = '',
      advertiserId = loginAdvertiserId,
      description = '',
      status = IntervalMailSendingStatus.INACTIVE,
      query = {},
      notification = {},
    } = intervalReport
    this.isAdminUser = isAdminUser
    this.id = id
    this.name = name
    this.advertiserId = advertiserId
    this.description = description
    this.status = status
    this.query = new IntervalReportQuery(Object.assign(query))
    this.notification = new IntervalReportNotification(
      Object.assign(notification, this.isIntervalMailActive()),
    )
  }

  isIntervalMailActive() {
    return this.status === IntervalMailSendingStatus.ACTIVE
  }

  async fetchInsertionOrderList(keyword = null) {
    const insertionOrders = await IOApi.fetchIOList({
      advertiserId: this.advertiserId,
      keyword,
      isIncludeDeleted: true,
    })
    this.insertionOrderList = insertionOrders.items.map(io => {
      io.name = `${io.name}（${io.anIoId}）`
      return io
    })
  }

  isValid() {
    return (
      this.name !== '' &&
      this.query.isValid(this.isAdminUser) &&
      this.notification.isValid(this.isIntervalMailActive())
    )
  }
}
